/**
 * Converts wind direction in degrees to cardinal direction and normalizes the value
 * @param degrees - Wind direction in degrees (can be negative or >360)
 * @returns Object containing normalized degrees and cardinal direction
 */
export function convertWindDirection(degrees: number): { normalizedDegrees: number; direction: string } {
    // Normalize degrees to 0-360
    const normalizedDegrees = ((degrees % 360) + 360) % 360;
    
    // Define cardinal directions and their degree ranges
    const directions = [
        { name: 'N', min: 337.5, max: 360 },
        { name: 'N', min: 0, max: 22.5 },
        { name: 'NE', min: 22.5, max: 67.5 },
        { name: 'E', min: 67.5, max: 112.5 },
        { name: 'SE', min: 112.5, max: 157.5 },
        { name: 'S', min: 157.5, max: 202.5 },
        { name: 'SW', min: 202.5, max: 247.5 },
        { name: 'W', min: 247.5, max: 292.5 },
        { name: 'NW', min: 292.5, max: 337.5 }
    ];

    // Find the matching direction
    const direction = directions.find(dir => 
        normalizedDegrees >= dir.min && normalizedDegrees < dir.max
    );

    return {
        normalizedDegrees: Number(normalizedDegrees.toFixed(1)),
        direction: direction ? direction.name : 'N' // Default to North if something goes wrong
    };
} 